<template lang="pug">
  section
    header.header-settings
      .tabs
        .tab.primary-text.active
          span Custom Domain

    section.sub-section
      h4 Dont Worry!
      p You still have your own feature watch instance running at https://{{company.subdomain}}.feature.watch, but some people want a little more control and we are ok with that! Enter your custom domain below and follow the steps to get up and running ASAP. Your custom domain will be used in all links pointing back to Feature Watch (emails, integrations, etc)

    has-access(allowance="customDomain")
      section.sub-section(v-if="!company.customDomain.domain")
        h4 Add your domain
        p Ensure that this domain is set up as a CNAME redirect to `cname.feature.watch` in your DNS
        form(@keyup.enter="submit", @submit.prevent="submit")
          AlertBox(v-if="error", type="danger", :text="error")
          div.form-field(:class="{error: $v.form.customDomain.$error, 'error-url': !$v.form.customDomain.domain}")
            label
              h6 Domain
              div.form-field-with-prefix
                .prefix https://
                input(v-model="$v.form.customDomain.$model", type="text", placeholder="features.yoursite.com")
          div.form-field.no-margin
            SubmitButton(label="Add Domain", :formState="formState")

      section.sub-section(v-if="company.customDomain.domain")
        .info-field
          h6 Your Domain
          p {{company.customDomain.domain}}
        .info-field
          h6 Verified
          font-awesome-icon(:icon="['fas', 'times']", v-if="!company.customDomain.verified")
          font-awesome-icon(:icon="['fas', 'check']", v-if="company.customDomain.verified")
        .info-field
          h6 SSL Certificate Enabled
          font-awesome-icon(:icon="['fas', 'times']", v-if="!company.customDomain.ssl")
          font-awesome-icon(:icon="['fas', 'check']", v-if="company.customDomain.ssl")
        div.form-field.no-margin
          button.button.button-alert(type="button", @click="deleteDomain")
            span Delete Domain
</template>

<script>

import { required, url, maxLength } from 'vuelidate/lib/validators'
import { form } from '@/mixins/form'
import { mapState } from 'vuex'

export default {
  name: 'SettingsCustomDomain',
  mixins: [form],
  mounted () {
    if(this.company.customDomain.domain && !this.company.customDomain.verified){
      this.checkDomain()
    }
  },
  beforeDestroy(){
    window.clearInterval(this.check)
  },
  data () {
    return {
      formState: 'initial',
      form: {
        customDomain: ''
      },
      check: '',
      error: null
    }
  },
  validations: {
    form: {
      customDomain: {
        required,
        maxLength: maxLength(100)
      }
    }
  },
  computed: {
    ...mapState({
      company: state => state.company,
    })
  },
  methods: {
    checkDomain(){
      if(!this.company.customDomain.domain){
        window.clearInterval(this.check)
      }
      this.check = setInterval(function(){
        console.log("verifying domain " + new Date())
        this.$store.dispatch('verifyCustomDomain').then(() => {
          if(this.company.customDomain.verified && this.company.customDomain.ssl){
            window.clearInterval(this.check)
          }
        }, errors => {
          console.log(errors)
        })
      }.bind(this), 10000)
    },
    deleteDomain(){
      console.log("deleting")
      let companyData = {
        customDomain: {
          verified: false,
          ssl: false
        }
      }
      this.$store.dispatch('updateCompany', companyData).then(() => {
        this.form = {
          customDomain: ''
        }
        this.$v.$reset()
         window.clearInterval(this.check)
      }, errors => {
        console.log(errors)
      })

    },
    submit () {
      let companyData = {
        customDomain: {
          domain: this.form.customDomain,
          verified: false,
          ssl: false
        }
      }

      if (this.__formInvalid()) return
      this.formState = 'pending'

      this.$store.dispatch('updateCompany', companyData).then(() => {
        this.formState = 'success'
        this.form = {
          customDomain: ''
        }
        this.$v.$reset()
        this.error = null
        this.checkDomain()
      }, errors => {
        this.formState = 'error'
        this.error = errors

        console.log(errors)
      })
    }
  }
}
</script>

<style lang="stylus" scoped>
.pending
  color $text-light
  .name
    font-style italic
</style>
